// NZI: those bindings are here because the main component is not React based and still an html template

function setElementAttribute(dataTag,
    dataProp) {
    const elements = Array.from(document.getElementsByClassName('m2g-view'));

    return elements.map(element => {
        element.setAttribute(
            dataTag,
            dataProp
        );
    })
}

Mobi2Go.Order.bind('updateTotal', total => {
    if (total) {
        setElementAttribute(
            'data-order-total-10',
            Math.floor(total.toFloat() / 10)
        );
        setElementAttribute(
            'data-order-total-100',
            Math.floor(total.toFloat() / 100)
        );
    }
});

Mobi2Go.Order.bind('updateLocation', location => {
    setElementAttribute('data-order-location-name', location?.name);
});

Mobi2Go.Order.bind('updateMenu', menu => {
    setElementAttribute('data-menu-name', menu?.name);
});

Mobi2Go.Order.bind('updateMethod', method => {
    setElementAttribute('data-order-method', method);
});

Mobi2Go.Order.bind('updateExpectedAt', expected_at => {
    setElementAttribute(
        'data-order-expected-at-day',
        expected_at?.format('dddd')
    );
    setElementAttribute(
        'data-order-expected-at-hour',
        expected_at?.format('HH')
    );
    setElementAttribute(
        'data-order-is-expected-today',
        Mobi2Go.Order.isExpectedToday()
    );
    setElementAttribute(
        'data-order-is-expected-tomorrow',
        Mobi2Go.Order.isExpectedTomorrow()
    );
});
Mobi2Go.Order.bind('updateVoucherCode', code => {
    setElementAttribute('data-order-voucher-code', code);
});
Mobi2Go.Order.bind('updatePaymentMethod', method => {
    setElementAttribute('data-order-payment-method', method);
});
Mobi2Go.Order.bind('updateKioskId', kiosk_id => {
    setElementAttribute('data-order-kiosk-id', kiosk_id);
});

